import { useRequestCompileContext } from 'client/components/schema/requests/compile-context/RequestCompileContext';
import { IMetadata } from 'common/schema/metadata/Metadata';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { IWidget } from 'common/schema/widget/Widget';
import { contextualFormWidgetProps } from './contextualFormWidgetProps';

/**
 * Hook per ottenere proprietà aggiuntive, comuni, per tutti i FormWidget,
 * come ad esempio la condizionalità o la pre-valorizzazione contestuale.
 */
export function useFormWidgetProps(widget: IWidget, codes: string[] = []) {
  const context = useRequestCompileContext();

  const metadatas = codes.length
    ? MetadataLogic.multipleFromWidget(widget, codes)
    : [MetadataLogic.singleFromWidget(widget)];

  return metadatas.map(m => ({
    // Valori contestuali (autofill)
    ...contextualFormWidgetProps(context.requestPreview, widget, m)
  }));
}
